module.exports = __webpack_public_path__ + "img/perfil_hiperlordotico.08693f10.jpg";